import { useEffect } from 'react';
import { getTokenFireBase } from 'modules/user/hooks/useRegister';
import { useAuthContext } from 'store/context/auth/auth-context';

export const AppLoaded = () => {
  const { isLoggedIn } = useAuthContext();
  useEffect(() => {
    if (isLoggedIn) getTokenFireBase();
    window?.ReactNativeWebView?.postMessage('AppLoaded');
  }, [isLoggedIn]);
  return null;
};
